import { OvlAddScreen } from "../../../_ovlclient/src/global/globals"
import { ScreenSYSTranslation } from "./screens/translation"

export const SYSTranslation_Init = () => {
  OvlAddScreen(ScreenSYSTranslation, "SYSTranslation")
}
